import axios from 'axios'

const apiUrl = window.location.host !== 'kraus-blocks.ru' ? '//api.containers.immercyb.com/' : '//api.containers.immercyb.com/'

const api = axios.create({
  baseURL: apiUrl,
  timeout: 100000
})

export default api
